import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

import { PresentationComponent } from './presentation/presentation.component';
import { ComponentsComponent } from './components/components.component';
import { SectionsComponent } from './sections/sections.component';
import { AboutusComponent } from './examples/aboutus/aboutus.component';
import { AddproductComponent } from './examples/addproduct/addproduct.component';
import { BlogpostComponent } from './examples/blogpost/blogpost.component';
import { BlogpostsComponent } from './examples/blogposts/blogposts.component';
import { ContactusComponent } from './examples/contactus/contactus.component';
import { DiscoverComponent } from './examples/discover/discover.component';
// import { EcommerceComponent } from './examples/ecommerce/ecommerce.component';
import { LandingComponent } from './examples/landing/landing.component';
import { LoginComponent } from './examples/login/login.component';
import { ProductpageComponent } from './examples/productpage/productpage.component';
import { ProfileComponent } from './shared/profile/profile.component';
import { RegisterComponent } from './examples/register/register.component';
import { SearchComponent } from './examples/search/search.component';
import { SettingsComponent } from './examples/settings/settings.component';
import { TwitterComponent } from './examples/twitter/twitter.component';
import { Page404Component } from './examples/page404/page404.component';
import { Page422Component } from './examples/page422/page422.component';
import { Page500Component } from './examples/page500/page500.component';
import { NucleoiconsComponent } from './components/nucleoicons/nucleoicons.component';
import { MainComponent } from './main/main.component';
import { ShoppingCartComponent } from './shared/shopping-cart/shopping-cart.component';
import { EcommerceComponent } from './ecommerce/ecommerce.component';
import { ProductPageComponent } from './ecommerce/productpage/productpage.component';
import { CheckoutComponent } from './shared/checkout/checkout.component';
import { OrderConfirmationComponent } from './shared/checkout/orderConfirmation/orderConfirmation.component';

const routes: Routes =[
    { path: 'presentation',         component: PresentationComponent },
    { path: 'components',           component: ComponentsComponent },
    { path: 'sections',             component: SectionsComponent },
    { path: 'nucleoicons',          component: NucleoiconsComponent },
    { path: 'examples/aboutus',     component: AboutusComponent },
    { path: 'examples/addproduct',  component: AddproductComponent },
    { path: 'examples/blogpost',    component: BlogpostComponent },
    { path: 'examples/blogposts',   component: BlogpostsComponent },
    { path: 'examples/contactus',   component: ContactusComponent },
    { path: 'examples/discover',    component: DiscoverComponent },
    // { path: 'examples/ecommerce',   component: EcommerceComponent },
    { path: 'examples/landing',     component: LandingComponent },
    { path: 'examples/login',       component: LoginComponent },
    { path: 'examples/productpage', component: ProductpageComponent },
    { path: 'examples/register',    component: RegisterComponent },
    { path: 'examples/search',      component: SearchComponent },
    { path: 'examples/settings',    component: SettingsComponent },
    { path: 'examples/twitter',     component: TwitterComponent },
    { path: 'examples/page404',     component: Page404Component },
    { path: 'examples/page422',     component: Page422Component },
    { path: 'examples/page500',     component: Page500Component },
    { path: 'cart',                 component: ShoppingCartComponent },
    { path: 'shop',                 component: EcommerceComponent },
    { path: 'shop/product/:id',     component: ProductPageComponent },
    { path: 'shop/checkout',        component: CheckoutComponent },
    { path: 'shop/order/:id',       component: OrderConfirmationComponent },
    { path: 'profile',              component: ProfileComponent },
    { path: '',                     component: MainComponent },
    { path: '**', redirectTo: '', pathMatch: 'full' },
    { path: '', redirectTo: '', pathMatch: 'full' }
];

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        RouterModule.forRoot(routes)
    ],
    exports: [
    ],
})
export class AppRoutingModule { }
